"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layer = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _find = _interopRequireDefault(require("lodash/find"));
var _padStart = _interopRequireDefault(require("lodash/padStart"));
var _extend = _interopRequireDefault(require("lodash/extend"));
var _Vector = _interopRequireDefault(require("ol/layer/Vector.js"));
var _Feature = _interopRequireDefault(require("ol/Feature.js"));
var _Point = _interopRequireDefault(require("ol/geom/Point.js"));
var _Projection = _interopRequireDefault(require("ol/proj/Projection.js"));
var _proj = require("ol/proj");
var _Vector2 = _interopRequireDefault(require("ol/source/Vector.js"));
var _Style = _interopRequireDefault(require("ol/style/Style.js"));
var _Icon = _interopRequireDefault(require("ol/style/Icon.js"));
var _Text = _interopRequireDefault(require("ol/style/Text.js"));
var _Circle = _interopRequireDefault(require("ol/style/Circle.js"));
var _Fill = _interopRequireDefault(require("ol/style/Fill.js"));
var _Stroke = _interopRequireDefault(require("ol/style/Stroke.js"));
var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON.js"));
var _map = require("../map");
var _TrainTooltip = _interopRequireDefault(require("../../components/TrainTooltip"));
var _utilities = require("../../../../utilities");
var _ghost = _interopRequireDefault(require("../../../../assets/icons/ghost.png"));
var _frontOfBus = _interopRequireDefault(require("../../../../assets/icons/front-of-bus.png"));
var _helpers = require("../../../lib/helpers");
var _constants = require("../../../lib/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import ol from "openlayers";
// import TrainTooltip from '../../components/train-tooltip';
var UNTAGGED_COLOR = '#9E9E9E';
var layer = new _Vector["default"]({
  visible: true,
  updateWhileAnimating: true,
  updateWhileInteracting: true,
  name: "trains",
  zIndex: _constants.TRAIN_Z_LEVEL
});

// set train id based on trip (if available), otherwise use the vehicle id for non-revenue trains
exports.layer = layer;
var getTrainId = function getTrainId(_ref) {
  var trip = _ref.trip,
    vehicle = _ref.vehicle;
  return trip ? trip.tripId : "NR-".concat(vehicle.id);
};

// Init layer
_map.map.addLayer(layer);

// Init stream subscriptions
var trains = {
  immediateUpdate: function immediateUpdate(trains, selected) {
    console.log('in immediate update');
    var features = trains === null || trains === void 0 ? void 0 : trains.map(function (train) {
      var _train$properties;
      // Create feature with location
      var _train$geometry = train === null || train === void 0 ? void 0 : train.geometry,
        coordinates = _train$geometry.coordinates;
      var feature = new _Feature["default"]({
        geometry: new _Point["default"]((0, _proj.transform)([coordinates[0], coordinates[1]], "EPSG:4326", "EPSG:900913")),
        name: train === null || train === void 0 ? void 0 : (_train$properties = train.properties) === null || _train$properties === void 0 ? void 0 : _train$properties.vehicle
      });
      // set properties & style
      feature.setProperties(train === null || train === void 0 ? void 0 : train.properties);
      feature.setStyle(trainStyleFunction(feature, selected));
      feature.setId(train.id);
      return feature;
    });
    layer.setSource(new _Vector2["default"]({
      features: features
    }));
  },
  handleUpdate: function handleUpdate(trains) {
    var renderNow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var doNotAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isPlaying = arguments.length > 3 ? arguments[3] : undefined;
    var selected = arguments.length > 4 ? arguments[4] : undefined;
    // playback is very rapid, currently 200 ms / tick.  Need to reduce animation frames to hopefully smooth it out
    var slices = isPlaying ? 15 : 30;
    if (trains) {
      var incomingTrainPositions = (0, _helpers.createTrainPositionLookup)(trains === null || trains === void 0 ? void 0 : trains.features);
      var trainTranslationLineLookup = _objectSpread({}, incomingTrainPositions);
      var trainsToAnimate = [];
      var trainsToLeaveAlone = [];
      var transformedPointsObj = {};
      var source = layer.getSource();
      // attempt to see if the trains layer already has features in it; to detect if this is the first load of the app or not
      var currentFeatures = source === null || source === void 0 ? void 0 : source.getFeatures();
      if (!!(currentFeatures !== null && currentFeatures !== void 0 && currentFeatures.length)) {
        source.forEachFeature(function (feat) {
          var thisTrainProps = feat.getProperties();
          if (trainTranslationLineLookup[thisTrainProps.name]) {
            // I found a train in the outgoing list that is present in the incoming one; i want to prepare to animate it
            trainTranslationLineLookup[thisTrainProps.name].latLon.push([thisTrainProps.longitude, thisTrainProps.latitude]);
            var points = trainTranslationLineLookup[thisTrainProps.name].latLon || null;
            var trainDidMove = points[0][0] !== points[1][0] || points[0][1] !== points[1][1];
            //console.log(trainDidMove)
            if (trainDidMove) {
              var hopefullyPoints = (0, _helpers.calculatePoints)(points[0], points[1], slices);
              transformedPointsObj[thisTrainProps.name] = hopefullyPoints;
              trainsToAnimate.push(feat);
            } else {
              trainsToLeaveAlone.push(feat);
            }
          }
          // lookup object is constructed
        });
        // forEachFeature ended
      }
      // this will be the initial layer of trains on the first load, and will be the ultimate layer once animation concludes.
      var features = trains === null || trains === void 0 ? void 0 : trains.features.map(function (train) {
        var _train$properties2;
        // Create feature with location
        var _train$geometry2 = train === null || train === void 0 ? void 0 : train.geometry,
          coordinates = _train$geometry2.coordinates;
        var feature = new _Feature["default"]({
          geometry: new _Point["default"]((0, _proj.transform)([coordinates[0], coordinates[1]], "EPSG:4326", "EPSG:900913")),
          name: train === null || train === void 0 ? void 0 : (_train$properties2 = train.properties) === null || _train$properties2 === void 0 ? void 0 : _train$properties2.vehicle
        });
        // set properties & style
        feature.setProperties(train === null || train === void 0 ? void 0 : train.properties);
        feature.setStyle(trainStyleFunction(feature, isPlaying, selected));
        feature.setId(train.id);
        return feature;
      });
      if (!currentFeatures || currentFeatures.length === 0) {
        console.log('just setting the source');
        layer.setSource(new _Vector2["default"]({
          features: features
        }));
      }
      var animationPayload = [];
      // i have my trains to animate and trains to leave alone, now i need to create a full list of features
      // for each frame of animation - create new features for the trains that are moving, and fold in the existing array
      // of trains to leave static
      var _loop = function _loop(_i) {
        if (_i < slices) {
          var newTrains = [].concat(trainsToLeaveAlone);
          // I have to loop through the trains to animate, create a new feature at each step
          // of the translation points
          trainsToAnimate.forEach(function (t) {
            var thisTrainProps = t.getProperties();
            var id = thisTrainProps.vehicle;
            var thisTrainPoints = transformedPointsObj[id][_i];
            var matchingTrainObj = trains.features.find(function (train) {
              return train.properties.vehicle === id;
            });
            if (thisTrainPoints) {
              var feature = new _Feature["default"]({
                geometry: new _Point["default"]((0, _proj.transform)([thisTrainPoints[0], thisTrainPoints[1]], "EPSG:4326", "EPSG:900913")),
                name: id
              });
              feature.setProperties(matchingTrainObj === null || matchingTrainObj === void 0 ? void 0 : matchingTrainObj.properties);
              feature.setStyle(trainStyleFunction(feature, isPlaying, selected));
              feature.setId(t.id_);
              newTrains.push(feature);
            }
          });
          // console.log('pushing into animation, does i reach slices? ', i, slices)
          animationPayload.push(newTrains);
        }
      };
      for (var _i = 0; _i <= slices + 1; _i++) {
        _loop(_i);
      }
      var i = 1;
      var animateTrains = function animateTrains(frames, speed) {
        setTimeout(function () {
          layer.setSource(new _Vector2["default"]({
            features: animationPayload[i]
          }));
          i++;
          if (i < frames) {
            animateTrains(frames);
          }
          if (i === frames) {
            layer.setSource(new _Vector2["default"]({
              features: features
            }));
          }
        }, speed / frames);
      };

      // const animationSpeed = isPlaying? 200 : 800
      // if (currentFeatures && currentFeatures.length) {
      //   animateTrains(slices, animationSpeed)
      // }

      layer.setSource(new _Vector2["default"]({
        features: features
      }));
    }
  },
  getOverlay: function getOverlay(_ref2, trains, filter, enableTagging) {
    var id = _ref2.id,
      vehicle = _ref2.vehicle,
      entireTrainObj = _ref2.entireTrainObj,
      vehicle_status = _ref2.vehicle_status;
    // Set overlay position
    // debugger
    var filteredTrains = trains.features.filter(function (train) {
      return (0, _utilities.trainTaggedFilter)(train, filter);
    });
    var train = (0, _find["default"])(filteredTrains, function (train) {
      return train.properties.vehicleId && train.properties.vehicleId == entireTrainObj.vehicleId;
    });

    //const train = find(filteredTrains, train => train.properties.vehicle_status && train.properties.vehicle_status == vehicle_status);
    // cutoff for no train found
    if (!train || !train.properties.latitude && !train.properties.longitude) {
      return null;
    }
    // set position
    //const oneHundredMetersNorth = train.properties.latitude + .001
    _map.overlay.setPosition((0, _proj.transform)([train.properties.longitude, train.properties.latitude], "EPSG:4326", "EPSG:900913"));
    _map.overlay.setProperties({
      layer: "trains",
      tripId: train.trip ? train.trip.tripShortName : null,
      vehicle: train.properties.vehicleId
    });
    // output rendered content
    return /*#__PURE__*/_react["default"].createElement(_TrainTooltip["default"], {
      train: train,
      enableTagging: enableTagging
    });
  },
  getLegend: function getLegend() {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-section"
    }, "Delay"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: (0, _utilities.getDelayColor)(0)
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "< 4 minutes")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: (0, _utilities.getDelayColor)(5)
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "4 to 9 minutes")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: (0, _utilities.getDelayColor)(15)
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "10 to 19 minutes")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: (0, _utilities.getDelayColor)(25)
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "20 to 29 minutes")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: (0, _utilities.getDelayColor)(35)
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "30 to 39 minutes")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: (0, _utilities.getDelayColor)(45)
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "> 40 minutes")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-section"
    }, "Type"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-entry"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: UNTAGGED_COLOR
      },
      className: "legend-item square"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "legend-label"
    }, "Untagged")));
  }
};
var _default = trains; // Styles
exports["default"] = _default;
var BASE_ICON_STYLE = {
  opacity: 1,
  anchor: [0.5, 0.5]
};
var getStandardIconStyle = function getStandardIconStyle(svg) {
  return (0, _extend["default"])({}, BASE_ICON_STYLE, {
    src: "data:image/svg+xml;base64,".concat(btoa(svg))
  });
};
var getIEIconStyle = function getIEIconStyle(svg, scaleFactor, renderWidth) {
  var svgImage = new Image();
  svgImage.src = "data:image/svg+xml;base64,".concat(btoa(svg));
  var markerCanvas = document.createElement('canvas');
  markerCanvas.width = markerCanvas.height = renderWidth;
  svgImage.onload = function () {
    // workaround IE11 svg issues by rendering to a canvas element first
    var ctx = markerCanvas.getContext('2d');
    ctx.drawImage(svgImage, 0, 0);
  };
  return (0, _extend["default"])({}, BASE_ICON_STYLE, {
    scale: 1 / scaleFactor,
    imgSize: [renderWidth, renderWidth],
    img: markerCanvas
  });
};
var trainStyleCache = {};
var trainStyleFunction = function trainStyleFunction(feature, isPlaying, selected) {
  var _featureProps$vehicle, _featureProps$vehicle2;
  var featureProps = feature.getProperties();
  var isBus = featureProps.vehicle_type === 'bus';
  var trip = featureProps.trip_short_name;
  var delay = featureProps.delay_sec;
  var bearing = (featureProps === null || featureProps === void 0 ? void 0 : featureProps.bearing) || 0;
  var vehicleStatus = featureProps === null || featureProps === void 0 ? void 0 : featureProps.vehicle_status;
  var forceGreyIcon = !trip || vehicleStatus === 'UNTAGGED' || vehicleStatus === 'NON-REVENUE';

  // console.log('looking at trains for non revenue ones, feature props veh status: ', featureProps.vehicle_status)
  var direction = 1;
  var statusColor = !trip || delay === undefined ? UNTAGGED_COLOR : (0, _utilities.getDelayColor)(Math.round(delay / 60));
  if (forceGreyIcon) {
    statusColor = UNTAGGED_COLOR;
  }
  var zIndex = trip ? _constants.TRAIN_Z_LEVEL + 1 : _constants.TRAIN_Z_LEVEL; // render untagged trains beneath all others
  var renderForIE = (0, _utilities.isIE)();
  var width = 65;
  var inboundPath = "M53.8774339,27.6784414 L46.3529668,23.9862733 C39.1072695,21.430934 31.0404671,23.9563444 26.4756193,30.2329431 C21.8394011,36.4680326 21.8412584,45.0343524 26.4886744,51.2846915 C31.0479372,57.5538025 39.1192095,60.0648541 46.4951849,57.5135527 L53.8738752,53.8232917 L77.8808477,41.7582455 C78.374319,41.5102444 78.5733119,40.9091623 78.3253109,40.415691 C78.2299477,40.2259378 78.0766513,40.0714713 77.8876286,39.974668 L53.8774339,27.6784414 Z";
  if (!bearing) {
    inboundPath = null;
    width = 85;
  }
  var scaleFactor = window.devicePixelRatio || 1;
  var renderWidth;
  if (renderForIE) {
    // we're going to render to a canvas element to workaround SVG
    // issues in IE11, so we need to do some scaling to accommodate
    // pixel-doubling (retina) displays
    renderWidth = width * scaleFactor;
  } else {
    renderWidth = width;
  }
  var svg = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" width=\"".concat(renderWidth, "\" height=\"").concat(renderWidth, "\" viewBox=\"0 0 83 83\">\n    <path\n      stroke=\"").concat(statusColor, "\"\n      fill=\"").concat(direction == 0 ? "#fff" : statusColor, "\"\n      stroke-width=\"4\"\n      d=\"").concat(inboundPath, "\"\n      transform=\"rotate(").concat(bearing - 90, ", 41, 41)\" />\n    <circle\n      cx=\"41\"\n      cy=\"41\"\n      r=\"13.83\"\n      stroke-width=\"").concat(direction == 0 ? 0 : 3, "\"\n      stroke=\"#fff\"\n      fill=\"").concat(statusColor, "\"/>\n    <text\n      fill=\"#fff\"\n      font-size=\"12\"\n      font-family=\"proxima-nova, Proxima Nova\"\n      x=\"41\"\n      y=\"45\"\n      text-anchor=\"middle\">\n      ").concat(trip ? (0, _padStart["default"])(trip, 3, '0') : "", "\n    </text>\n  </svg>\n");
  var iconStyle = renderForIE ? getIEIconStyle(svg, scaleFactor, renderWidth) : getStandardIconStyle(svg);
  if (!isPlaying && featureProps !== null && featureProps !== void 0 && (_featureProps$vehicle = featureProps.vehicle_status) !== null && _featureProps$vehicle !== void 0 && (_featureProps$vehicle2 = _featureProps$vehicle.toLowerCase()) !== null && _featureProps$vehicle2 !== void 0 && _featureProps$vehicle2.includes('ghost')) {
    var isThisGhostSelected = selected.tripShortName === featureProps.trip_short_name;
    // iconStyle.opacity = isThisGhostSelected ? 1 : 0
    iconStyle.src = _ghost["default"];
    iconStyle.width = 30;
    iconStyle.height = 30;
  }
  if (isBus) {
    iconStyle.src = _frontOfBus["default"];
    iconStyle.width = 20;
    iconStyle.height = 20;
  }
  return new _Style["default"]({
    zIndex: zIndex,
    image: new _Icon["default"](iconStyle)
  });
};